import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface IListStateIconApprovedProps {
  noMargin?: boolean;
  tooltip?: string;
  color?: string;
  customColor?: string;
}

export const ListStateIconApproved = ({
    noMargin,
    tooltip,
    color,
    customColor,
}: IListStateIconApprovedProps) => (
    <ListStateIcon
        color={color}
        customColor={customColor}
        noMargin={noMargin}
        tooltip={tooltip}
        icon={CheckCircleIcon}
    />
);
